/**************************************************
 * Nombre:       Formacion_PorQue
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import {NEGRITA} from "../../../Constantes";
import {useFormulario} from "../../../Modulo_formularios/Hooks/useFormulario";
import logo from '../../../Recursos/logo_color.svg'


const Formacion_PorQue = () => {
    const {props} = useFormulario({valoresDefecto: {}})

    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: 3}}
            >

                <Grid container size={{xs: 12, sm: 12, md: 11}} sx={{justifyContent: 'flex-start'}}
                      spacing={8}
                >
                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 6}}
                        spacing={0}
                    >


                        <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 8}}>
                            <Typography sx={{fontSize: 40, fontFamily: NEGRITA, lineHeight: 1.1, fontWeight: 600}}>
                                Por que Estudiar TECNICO LABORAL POR COMPETENCIAS ASISTENTE ADMINISTRATIVO
                            </Typography>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 1}}>
                            <Typography
                                sx={{fontSize: 18}}>
                                El egresado del programa Técnico Laboral en Asistente Administrativo está preparado para
                                apoyar de manera eficiente las áreas administrativas, con El egresado del programa
                                Técnico Laboral en Asistente Administrativo está preparado para apoyar de manera
                                eficiente las áreas administrativas, conEl egresado del programa Técnico Laboral en
                            </Typography>
                        </Grid>


                    </Grid>

                    <Grid
                        container
                        justifyContent={'center'}
                        alignItems={'center'}
                        size={{xs: 12, sm: 12, md: 6}}
                        sx={{mt: 10}}
                    >

                        <img src={logo} width={'80%'} height={'auto'}/>
                    </Grid>

                </Grid>

            </Grid>

        </Grid>
    )

}
export default Formacion_PorQue

const items = [1, 2, 3, 4, 5, 6]